import { motion } from "framer-motion";

import SectionHeading from "@/components/SectionHeading";
import { iconRegistry } from "@/content/iconRegistry";

export default function ValuesSection({ content, dataTestId, className = "" }) {
  return (
    <section className={`py-16 md:py-24 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <SectionHeading title={content.title} description={content.description} />
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {content.values.map((value, index) => {
            const Icon = iconRegistry[value.icon];

            return (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-card rounded-3xl p-8 shadow-soft border border-border"
              >
                <div className="w-14 h-14 rounded-2xl bg-secondary/36 flex items-center justify-center mb-5 border border-secondary/45">
                  <Icon className="w-7 h-7 text-highlight" />
                </div>
                <h3 className="font-sans text-xl font-semibold text-foreground mb-3">{value.title}</h3>
                <p className="font-body text-muted-foreground leading-relaxed">{value.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
